import styled from "styled-components";
export const ChangerBtn = styled.button`
  background: transparent;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
`;
